/* eslint-disable simple-import-sort/imports */
import "./settingsModal.scss";

import { Map } from "immutable";
import { isEqual, isNil } from "lodash";
import PropTypes from "prop-types";
import PubSub from "pubsub-js";
import React, { Fragment, PureComponent } from "react";
import { connect } from "react-redux";

import ErrorBoundary from "../../components/errorBoundary";
import FormButton from "../../components/form/FormButton";
import ModalFooter from "../../components/modal/ModalFooter";
import ModalFooterRightGroup from "../../components/modal/ModalFooterRightGroup";
import ModalHeading from "../../components/modal/ModalHeading";
import ModalTabView from "../../components/modal/ModalTabView";
import ModalView from "../../components/modal/ModalView";
import ModalViewStack from "../../components/modal/ModalViewStack";
import PubSubTopics from "../../constants/pubSubTopics";
import { settingsErrorMessages } from "../../constants/settingsErrors";
import Dimensions from "../../constants/styles/dimensions";
import dialogs from "../../dialogs";
import batchOperations from "../../modules/batchOperations";
import chainReducer from "../../modules/chainReducer";
import definitionReducer, { definitionSelectors } from "../../modules/definition";
import { calendarOperations, calendarSelectors } from "../../modules/definition/calendar";
import dateFunctions from "../../modules/definition/calendar/dateFunctions";
import { typeSelectors } from "../../modules/definition/types";
import { itemSelectors } from "../../modules/items";
import { narrativeSelectors } from "../../modules/narrative";
import { preferencesSelectors } from "../../modules/preferences";
import { syncSettingsSelectors } from "../../modules/sync/settings";
import { uiStateOperations } from "../../modules/uiState";
import { nativeCommsBroadcastMessageTypes } from "../../nativeComms";
import calendarTypes from "../../types/calendarTypes";
import { mergeDispatchToProps, wrapEditingComponent } from "../../utils/codeSplit";
import preprocessorQuery from "../../utils/preprocessorQuery";
import { trackEvent } from "../../utils/trackAnalytics";
import AdvancedSettingsModal from "./advancedSettingsModal";
import CalendarSettingsModal from "./calendarSettingsModal";
import selectors from "./selectors";
import SettingsCardDetailsMobileTab from "./SettingsCardDetailsMobileTab";
import SettingsColorsTab from "./SettingsColorsTab";
import SettingsConfirmDeleteActionModal from "./SettingsConfirmDeleteActionModal";
import SettingsDataTab from "./SettingsDataTab";
import SettingsDateGroup from "./SettingsDateGroup";
import SettingsIosAppearanceGroup from "./SettingsIosAppearanceGroup";
import SettingsNarrativeGroup from "./SettingsNarrativeGroup";
import SettingsNarrativeTab from "./SettingsNarrativeTab";
import SettingsPropertyGroup from "./SettingsPropertyGroup";
import { registrationSelectors } from "../../modules/registration";
import SettingsRangeTab from "./SettingsRangeTab";
import SettingsReferenceGroup from "./SettingsReferenceGroup";
import SettingsStrictNarrativeActionModal from "./SettingsStrictNarrativeActionModal";
import SettingsTypeGroup from "./SettingsTypeGroup";
import SettingsZeroDateModal from "./SettingsZeroDateModal";

import { narrativeSettingsOperations, narrativeSettingsSelectors } from "../../modules/definition/narrativeSettings";
import screenModes from "../../constants/screenModes";
import { withScreenContext } from "../../components/screen/ScreenContext";
import SettingsIosAboutGroup from "./SettingsIosAboutGroup";

const isMobile = preprocessorQuery.isMobile();
const isIos = preprocessorQuery.isIos();
const isHarvard = preprocessorQuery.isHarvard();

const chainedDefinitionReducer = chainReducer(definitionReducer);

const GLOBAL_PREFERENCES_TAB_ID = "globalAppearanceTab";

class SettingsModal extends PureComponent {
  constructor(props, context) {
    super(props, context);

    this.state = {
      localStore: null,
      isValid: true,
      validationError: null,
      advancedSettingsOpen: false,
      advancedSettingsActiveTab: null,
      confirmDeleteActionOpen: false,
      zeroDateOpen: false,
      editCalendarOpen: false,
      deletedTypesWithItems: null,
      activeTab: null,
      strictNarrativeOptionOpen: false,
      strictNarrativeCorrectiveOption: null
    };

    this.dispatchLocal = this.dispatchLocal.bind(this);
    this.onDoneClick = this.onDoneClick.bind(this);
    this.onCloseClick = this.onCloseClick.bind(this);
    this.onSaveCustomClick = this.onSaveCustomClick.bind(this);
    this.onAdvancedSettingsClick = this.onAdvancedSettingsClick.bind(this);
    this.onAdvancedSettingsDone = this.onAdvancedSettingsDone.bind(this);
    this.onAdvancedSettingsCancel = this.onAdvancedSettingsCancel.bind(this);
    this.onCalendarTypeChange = this.onCalendarTypeChange.bind(this);
    this.onStrictFolderStructureChange = this.onStrictFolderStructureChange.bind(this);
    this.onZeroDateDone = this.onZeroDateDone.bind(this);
    this.onZeroDateCancel = this.onZeroDateCancel.bind(this);

    this.onConfirmDeleteActionDone = this.onConfirmDeleteActionDone.bind(this);
    this.onConfirmDeleteActionCancel = this.onConfirmDeleteActionCancel.bind(this);
    this.onStrictNarrativeActionDone = this.onStrictNarrativeActionDone.bind(this);
    this.onStrictNarrativeActionCancel = this.onStrictNarrativeActionCancel.bind(this);

    this.onEditCalendarClick = this.onEditCalendarClick.bind(this);
    this.onEditCalendarDone = this.onEditCalendarDone.bind(this);
    this.onEditCalendarCancel = this.onEditCalendarCancel.bind(this);
    this.onTabClick = this.onTabClick.bind(this);
    this.onShowPreferencesModal = this.onShowPreferencesModal.bind(this);

    this._globalPreferencesTabIndex = -1;
  }

  componentWillMount() {
    this.copyLocalStore(this.props);
  }

  componentDidMount() {
    PubSub.publish(PubSubTopics.sendNativeMessage, {
      msg: nativeCommsBroadcastMessageTypes.SETTINGS_OPENED
    });
    this._pubSubEscapeKeyDownToken = PubSub.subscribe(PubSubTopics.escapeKeyDown, this.onCloseClick);
  }

  componentWillUnmount() {
    PubSub.publish(PubSubTopics.sendNativeMessage, {
      msg: nativeCommsBroadcastMessageTypes.SETTINGS_CLOSED
    });
    PubSub.unsubscribe(this._pubSubEscapeKeyDownToken);
  }

  copyLocalStore(props) {
    this.setState({
      localStore: props.localStore,
      isValid: true
    });
  }

  dispatchLocal(a) {
    const newStore = this.state.localStore.set(
      "definitions",
      chainedDefinitionReducer(this.state.localStore.definitions, a, this.state.localStore)
    );
    const validationResult = selectors.isSettingsValid(newStore);
    this.setState({
      localStore: newStore,
      ...validationResult
    });
  }

  applyChanges(typeChanges) {
    this.props.onDoneClick(
      this.state.localStore.definitions,
      typeChanges,
      this.state.strictNarrativeCorrectiveOption,
      this.state.localStore,
      this.state.shouldShowPreferencesModal
    );
  }

  onDoneClick(_e, showPreferencesModalAfterClose) {
    if (!this.state.isValid) {
      //eslint-disable-next-line no-console
      console.log(`onDoneClick() called when settings are not valid, ignoring...`);
      return;
    }
    // First, work out if we need to show a confirmation prompt at all
    const oldEnabledTypes = definitionSelectors.getTypesById(this.props.localStore);
    const enabledTypes = definitionSelectors.getTypesById(this.state.localStore);
    const deletedTypes = oldEnabledTypes.filter(t => !enabledTypes.has(t.id));

    // Now we need to work out which of those deletedTypes actually have items
    const deletedTypesWithItems = deletedTypes.filter(
      t => itemSelectors.getItemsOfType(this.props.localStore, t.id).size > 0
    );

    if (deletedTypesWithItems.size) {
      this.setState({
        confirmDeleteActionOpen: true,
        deletedTypesWithItems,
        shouldShowPreferencesModal: Boolean(showPreferencesModalAfterClose)
      });
    } else {
      this.setState(
        {
          shouldShowPreferencesModal: Boolean(showPreferencesModalAfterClose)
        },
        () => {
          trackEvent("applySettingsWithoutDeleteConfirmation", "settingsModal");
          this.applyChanges(Map());
        }
      );
    }
  }

  onAdvancedSettingsClick(advancedSettingsActiveTab) {
    this.setState({
      advancedSettingsOpen: true,
      advancedSettingsActiveTab: Number.isInteger(advancedSettingsActiveTab) ? advancedSettingsActiveTab : null
    });

    trackEvent("advancedSettingsOpen", "settingsModal");
  }

  // Note: newStore is *only* passed in by Desktop, not iOS, which has been
  // feeding changes through to Settings the whole time
  onAdvancedSettingsDone(newStore) {
    let stateUpdate = {
      advancedSettingsOpen: false,
      advancedSettingsActiveTab: null
    };
    //#!if iOS !== true
    const validationResult = selectors.isSettingsValid(newStore);
    stateUpdate.localStore = newStore;
    stateUpdate.isValid = validationResult.isValid;
    stateUpdate.validationError = validationResult.validationError;
    //#!endif
    this.setState(stateUpdate);

    trackEvent("advancedSettingsDone", "settingsModal");
  }

  onAdvancedSettingsCancel() {
    this.setState({ advancedSettingsOpen: false, advancedSettingsActiveTab: null });
    trackEvent("advancedSettingsCancel", "settingsModal");
  }

  onCalendarTypeChange(newCalendarType) {
    const calendar = this.state.localStore.definitions.calendar;
    // Firstly, work out whether we need to show the zero date picker or not.
    // It needs to be shown if:
    //    1) the calendar type has changed;
    //    2) we are moving to or from Absolute Dates; and
    //    3) there is at least one item or calendar marker in the timeline.

    if (calendar.calendarType !== newCalendarType) {
      const toOrFromAbsolute =
        calendar.calendarType === calendarTypes.CALENDAR_TYPE_DATE_TIME ||
        newCalendarType === calendarTypes.CALENDAR_TYPE_DATE_TIME;
      const itemsExist = selectors.doesTimelineHaveItemsOrMarkers(this.state.localStore);
      if (toOrFromAbsolute && itemsExist) {
        this._incomingCalendarType = newCalendarType;
        this.setState({ zeroDateOpen: true });
      } else {
        this.dispatchLocal(calendarOperations.changeCalenderType(newCalendarType));
      }
    }

    trackEvent("calendarTypeChange", "settingsModal");
  }

  onZeroDateDone(date) {
    if (!isNil(this._incomingCalendarType) && date) {
      this.dispatchLocal(batchOperations.changeCalendarTypeAndZeroDate(this._incomingCalendarType, date.timestamp));
    }
    this._incomingCalendarType = null;
    this.setState({ zeroDateOpen: false });
  }

  onZeroDateCancel() {
    this.setState({ zeroDateOpen: false });
  }

  onConfirmDeleteActionDone(typeChanges) {
    trackEvent("applySettingsWithDeleteConfirmation", "settingsModal");

    // If they click Ok, then the changes should be applied
    this.applyChanges(typeChanges);
  }

  onConfirmDeleteActionCancel() {
    trackEvent("cancelSettingsDeleteConfirmation", "settingsModal");

    // If they click Cancel, just hide the dialog
    this.setState({
      confirmDeleteActionOpen: false,
      deletedTypesWithItems: null
    });
  }

  onStrictFolderStructureChange(useStrict) {
    //#!if readonly !== true
    // Was it already set to be strict?
// const wasStrict = this.state.localStore.definitions.narrativeSettings.strictFolderStructure;
// if (useStrict && !wasStrict) {
// trackEvent("changeToStrictNarrative", "settingsModal");
      // If they are turning strict on, and some of the data is currently invalid,
      // then we want to show the prompt to find out how they
      // want to handle the change before we apply it.
// if (this.props.isStrictNarrativeViolated) {
// this.setState({
// strictNarrativeOptionOpen: true
// });
// } else {
        // If nothing would violate strict anyway, we can turn it straight on
// this.dispatchLocal(narrativeSettingsOperations.setStrictFolderStructure(true));
// }
// } else if (!useStrict && wasStrict) {
// trackEvent("changeToNonStrictNarrative", "settingsModal");
      // If they are turning it off, apply the change immediately
// this.dispatchLocal(narrativeSettingsOperations.setStrictFolderStructure(false));
// this.setState({
// strictNarrativeCorrectiveOption: null
// });
// }
    //#!endif
  }

  onStrictNarrativeActionDone(strictNarrativeCorrectiveOption) {
    //#!if readonly !== true
// trackEvent("chooseSettingsStrictNarrativeConfirmation", "settingsModal");
    // If they click Ok, then the changes should be applied
// this.setState({
// strictNarrativeCorrectiveOption,
// strictNarrativeOptionOpen: false
// });
// this.dispatchLocal(narrativeSettingsOperations.setStrictFolderStructure(true));
    //#!endif
  }

  onStrictNarrativeActionCancel() {
    trackEvent("cancelSettingsStrictNarrativeConfirmation", "settingsModal");
    // If they cancel, revert back to non-strict setting
    this.setState({
      strictNarrativeOptionOpen: false,
      strictNarrativeCorrectiveOption: null
    });
  }

  onEditCalendarClick() {
    trackEvent("editCalendarClick", "settingsModal");

    this.setState({ editCalendarOpen: true });
  }

  onEditCalendarDone(newStore) {
    let stateUpdate = {
      editCalendarOpen: false
    };
    //#!if iOS !== true
    const validationResult = selectors.isSettingsValid(newStore);
    stateUpdate.localStore = newStore;
    stateUpdate.isValid = validationResult.isValid;
    stateUpdate.validationError = validationResult.validationError;
    //#!endif
    this.setState(stateUpdate);

    trackEvent("editCalendarDone", "settingsModal");
  }

  onEditCalendarCancel() {
    trackEvent("editCalendarCancel", "settingsModal");

    this.setState({ editCalendarOpen: false });
  }

  onSaveCustomClick() {
    this.props.onSaveCustomClick(this.state.localStore.definitions);
  }

  onCloseClick() {
    if (
      this.state.advancedSettingsOpen ||
      this.state.zeroDateOpen ||
      this.state.editCalendarOpen ||
      this.state.confirmDeleteActionOpen
    ) {
      return;
    }
    if (
      this.state.localStore !== this.props.localStore &&
      !isEqual(this.state.localStore.toJS(), this.props.localStore.toJS())
    ) {
      const msg = "Are you sure you want to close without applying your Settings changes?";
      dialogs.okCancelPrompt(msg, result => {
        if (result) {
          trackEvent("cancelSettingsChanges", "settingsModal");
          this.props.onCloseClick();
        }
      });
    } else {
      trackEvent("cancelSettingsChanges", "settingsModal");
      this.props.onCloseClick();
    }
  }

  onTabClick(index) {
    trackEvent("editCalendarCancel", "settingsModal");
    this.setState({
      activeTab: index
    });
  }

  onShowPreferencesModal() {
    //#!if iOS === true
// this.onTabClick(null);
// this.onTabClick(this._globalPreferencesTabIndex);
    //#!else
    const msg = "Are you sure you want to save your Settings and go to Global Preferences?";
    dialogs.okCancelPrompt(msg, result => {
      if (result) {
        this.onDoneClick(null, true);
      }
    });
    //#!endif
  }

  getItemCardTab() {
    return isMobile && this.props.screenContext && this.props.screenContext.screenMode === screenModes.MobilePortrait
      ? {
        icon: "settingsItemCard",
        label: "Card Details",
        view: (
          <SettingsCardDetailsMobileTab
            includeNarrative={this.state.localStore.definitions.includeNarrative}
            mobileItemCardViewSettings={this.state.localStore.definitions.mobileItemCardViewSettings}
            timelineViewSettings={this.state.localStore.definitions.timelineViewSettings}
            narrativeViewSettings={this.state.localStore.definitions.narrativeViewSettings}
            dispatchLocal={this.dispatchLocal}
          />
        )
      }
      : null;
  }

  tabViews() {
    const tabs = [
      //#!if iOS === true
// {
// icon: "settingsRange",
// label: "Calendar and Date",
// view: (
// <SettingsDateGroup
// calendar={this.state.localStore.definitions.calendar}
// autoAdjustLevel={this.state.localStore.definitions.autoAdjustLevel}
// autoAdjustBackwardsLimit={this.state.localStore.definitions.autoAdjustBackwardsLimit}
// dispatchLocal={this.dispatchLocal}
// onEditCalendarClick={this.onEditCalendarClick}
// onCalendarTypeChange={this.onCalendarTypeChange}
// overrideNowTimestamp={definitionSelectors.getOverrideNowTimestamp(this.state.localStore)}
// onShowPreferencesModal={this.onShowPreferencesModal}
// />
// )
// },
// wrapEditingComponent({
// icon: "settingsNarrative",
// label: "Narrative",
// view: (
// <SettingsNarrativeGroup
// includeNarrative={this.state.localStore.definitions.includeNarrative}
// isSyncEnabled={this.props.isSyncEnabled}
// strictFolderStructure={this.state.localStore.definitions.narrativeSettings.strictFolderStructure}
// narrativeLabels={this.state.localStore.definitions.narrativeSettings.labels}
// autoAdjustLevel={this.state.localStore.definitions.autoAdjustLevel}
// autoAdjustBackwardsLimit={this.state.localStore.definitions.autoAdjustBackwardsLimit}
// dispatchLocal={this.dispatchLocal}
// onStrictFolderStructureChange={this.onStrictFolderStructureChange}
// enabledNarrativeTypes={typeSelectors.getNarrativeTypes(this.state.localStore)}
// defaultSequenceType={definitionSelectors.getDefaultSequenceType(this.state.localStore)}
// defaultNarrativeType={definitionSelectors.getDefaultNarrativeDocumentType(this.state.localStore)}
// narrativeViewHasItems={narrativeSelectors.getNarrativeHasItems(this.state.localStore)}
// narrativeNumbering={narrativeSettingsSelectors.getNarrativeNumbering(this.state.localStore)}
// />
// )
// }),
// wrapEditingComponent({
// icon: "settingsItemTypes",
// label: "Item Types",
// view: (
// <SettingsTypeGroup
// dispatchLocal={this.dispatchLocal}
// types={selectors.getAllOrderedTypes(this.state.localStore)}
// properties={selectors.getAllOrderedProperties(this.state.localStore)}
// references={selectors.getAllOrderedReferences(this.state.localStore)}
// onAdvancedSettingsClick={() => this.onAdvancedSettingsClick(0)}
// includeNarrative={this.state.localStore.definitions.includeNarrative}
// orderedSequenceTypes={typeSelectors.getOrderedSequenceTypes(this.state.localStore)}
// orderedNarrativeTypes={typeSelectors.getOrderedNarrativeDocumentTypes(this.state.localStore)}
// defaultSequenceType={definitionSelectors.getDefaultSequenceType(this.state.localStore)}
// defaultNarrativeType={definitionSelectors.getDefaultNarrativeDocumentType(this.state.localStore)}
// isValid={this.state.isValid}
// validationError={this.state.validationError}
// />
// )
// }),
// wrapEditingComponent({
// icon: "settingsRelationships",
// label: "Relationship Types",
// view: (
// <SettingsReferenceGroup
// dispatchLocal={this.dispatchLocal}
// types={selectors.getAllOrderedTypes(this.state.localStore)}
// properties={selectors.getAllOrderedProperties(this.state.localStore)}
// references={selectors.getAllOrderedReferences(this.state.localStore)}
// onAdvancedSettingsClick={() => this.onAdvancedSettingsClick(1)}
// includeNarrative={this.state.localStore.definitions.includeNarrative}
// orderedSequenceTypes={typeSelectors.getOrderedSequenceTypes(this.state.localStore)}
// orderedNarrativeTypes={typeSelectors.getOrderedNarrativeDocumentTypes(this.state.localStore)}
// defaultSequenceType={definitionSelectors.getDefaultSequenceType(this.state.localStore)}
// defaultNarrativeType={definitionSelectors.getDefaultNarrativeDocumentType(this.state.localStore)}
// />
// )
// }),
// wrapEditingComponent({
// icon: "settingsTypes",
// label: "Properties",
// view: (
// <SettingsPropertyGroup
// dispatchLocal={this.dispatchLocal}
// types={selectors.getAllOrderedTypes(this.state.localStore)}
// properties={selectors.getAllOrderedProperties(this.state.localStore)}
// references={selectors.getAllOrderedReferences(this.state.localStore)}
// onAdvancedSettingsClick={() => this.onAdvancedSettingsClick(2)}
// includeNarrative={this.state.localStore.definitions.includeNarrative}
// orderedSequenceTypes={typeSelectors.getOrderedSequenceTypes(this.state.localStore)}
// orderedNarrativeTypes={typeSelectors.getOrderedNarrativeDocumentTypes(this.state.localStore)}
// defaultSequenceType={definitionSelectors.getDefaultSequenceType(this.state.localStore)}
// defaultNarrativeType={definitionSelectors.getDefaultNarrativeDocumentType(this.state.localStore)}
// />
// )
// }),
      //#!else
      {
        icon: "settingsRange",
        label: "Calendar & Date",
        view: (
          <SettingsRangeTab
            calendar={this.state.localStore.definitions.calendar}
            overrideNowTimestamp={definitionSelectors.getOverrideNowTimestamp(this.state.localStore)}
            autoAdjustLevel={this.state.localStore.definitions.autoAdjustLevel}
            autoAdjustBackwardsLimit={this.state.localStore.definitions.autoAdjustBackwardsLimit}
            dispatchLocal={this.dispatchLocal}
            onEditCalendarClick={this.onEditCalendarClick}
            onCalendarTypeChange={this.onCalendarTypeChange}
            onStrictFolderStructureChange={this.onStrictFolderStructureChange}
            defaultSequenceType={definitionSelectors.getDefaultSequenceType(this.state.localStore)}
            onShowPreferencesModal={this.onShowPreferencesModal}
          />
        )
      },
      wrapEditingComponent({
        icon: "settingsNarrative",
        label: "Narrative",
        view: (
          <SettingsNarrativeTab
            includeNarrative={this.state.localStore.definitions.includeNarrative}
            isSyncEnabled={this.props.isSyncEnabled}
            strictFolderStructure={this.state.localStore.definitions.narrativeSettings.strictFolderStructure}
            narrativeNumbering={narrativeSettingsSelectors.getNarrativeNumbering(this.state.localStore)}
            narrativeLabels={this.state.localStore.definitions.narrativeSettings.labels}
            dispatchLocal={this.dispatchLocal}
            onStrictFolderStructureChange={this.onStrictFolderStructureChange}
            enabledNarrativeTypes={typeSelectors.getNarrativeTypes(this.state.localStore)}
            defaultSequenceType={definitionSelectors.getDefaultSequenceType(this.state.localStore)}
            defaultNarrativeType={definitionSelectors.getDefaultNarrativeDocumentType(this.state.localStore)}
            narrativeViewHasItems={narrativeSelectors.getNarrativeHasItems(this.state.localStore)}
          />
        )
      }),
      wrapEditingComponent({
        icon: "settingsItemTypes",
        label: "Data Types",
        view: (
          <SettingsDataTab
            dispatchLocal={this.dispatchLocal}
            types={selectors.getAllOrderedTypes(this.state.localStore)}
            properties={selectors.getAllOrderedProperties(this.state.localStore)}
            references={selectors.getAllOrderedReferences(this.state.localStore)}
            onAdvancedSettingsClick={this.onAdvancedSettingsClick}
            includeNarrative={this.state.localStore.definitions.includeNarrative}
            orderedSequenceTypes={typeSelectors.getOrderedSequenceTypes(this.state.localStore)}
            orderedNarrativeTypes={typeSelectors.getOrderedNarrativeDocumentTypes(this.state.localStore)}
            defaultSequenceType={definitionSelectors.getDefaultSequenceType(this.state.localStore)}
            defaultNarrativeType={definitionSelectors.getDefaultNarrativeDocumentType(this.state.localStore)}
            isValid={this.state.isValid}
            validationError={this.state.validationError}
          />
        )
      }),
      //#!endif
      wrapEditingComponent({
        icon: "settingsColors",
        label: "Colors",
        view: (
          <SettingsColorsTab
            colors={this.state.localStore.definitions.colors}
            dispatchLocal={this.dispatchLocal}
            onDoneClick={this.onDoneClick}
          />
        )
      }),
      this.getItemCardTab(),
      isIos
        ? {
          id: GLOBAL_PREFERENCES_TAB_ID,
          icon: "settingsTools",
          label: "Application-Wide Settings",
          view: <SettingsIosAppearanceGroup />
        }
        : null,
      isIos
        ? {
          icon: "settingsInfo",
          label: "About Aeon Timeline",
          view: <SettingsIosAboutGroup />
        }
        : null
    ].filter(t => t);

    this._globalPreferencesTabIndex = tabs.findIndex(t => t.id === GLOBAL_PREFERENCES_TAB_ID);

    return tabs;
  }

  renderModalFooter() {
    let modalFooter = null;

    const errorMessage = this.state.validationError
      ? settingsErrorMessages[this.state.validationError]
      : "Invalid settings must be corrected before saving.";

    // #!if iOS === true
// if (!this.state.isValid) {
// modalFooter = (
// <ModalFooter>
// <div className="warning">{errorMessage}</div>
// </ModalFooter>
// );
// }
    // #!else
    modalFooter = (
      <ModalFooter>
        <ModalFooterRightGroup>
          <div className="warning">{!this.state.isValid ? errorMessage : ""}</div>
          <FormButton primary={true} disabled={!this.state.isValid} label="OK" onClick={this.onDoneClick} />
        </ModalFooterRightGroup>
      </ModalFooter>
    );
    // #!endif
    return modalFooter;
  }

  renderSettingsModal() {
    const isBackgroundModal =
      this.state.advancedSettingsOpen ||
      this.state.zeroDateOpen ||
      this.state.confirmDeleteActionOpen ||
      this.state.editCalendarOpen ||
      this.state.strictNarrativeOptionOpen;

    const className = isBackgroundModal ? "backgroundModal" : null;

    let modalHeading = null;
    const modalFooter = this.renderModalFooter();
    const fixedHeight = Dimensions.MODAL_MAX_HEIGHT;

    // #!if iOS === true
// modalHeading = (
// <ModalHeading
// title="Timeline Settings"
// showCancel={true}
// onCancelClick={this.onCloseClick}
// showDone={true}
// onDoneClick={this.onDoneClick}
// doneDisabled={!this.state.isValid}
// />
// );
    // #!else
    modalHeading = <ModalHeading title="Timeline Settings" showCancel={true} onCancelClick={this.onCloseClick} />;
    // #!endif

    return (
      <ModalView className={className} header={modalHeading} footer={modalFooter} fixedHeight={fixedHeight}>
        <ErrorBoundary store={this.state.localStore}>
          <div style={{ width: "100%" }}>
            <ModalTabView
              activeTab={this.state.activeTab}
              tabs={this.tabViews()}
              disableTabSwitch={!this.state.isValid}
              onTabClick={this.onTabClick}
              //#!if iOS === true
// onDoneClick={this.onDoneClick}
// doneDisabled={!this.state.isValid}
// footer={modalFooter}
              //#!endif
            />
          </div>
        </ErrorBoundary>
      </ModalView>
    );
  }

  renderAdvancedSettings() {
    let advancedProps = {
      localStore: this.state.localStore,
      fontSize: this.props.globalFontSize,
      isValid: this.state.isValid,
      validationError: this.state.validationError
    };
    //#!if iOS === true
// advancedProps.dispatchLocal = this.dispatchLocal;
// advancedProps.onDoneClick = this.onDoneClick;
// advancedProps.onCloseClick = this.onAdvancedSettingsDone;
    //#!else
    advancedProps.onDoneClick = this.onAdvancedSettingsDone;
    advancedProps.onCloseClick = this.onAdvancedSettingsCancel;
    //#!endif

    return <AdvancedSettingsModal {...advancedProps} activeTab={this.state.advancedSettingsActiveTab} />;
  }

  renderZeroDateModal() {
    const calendar = calendarSelectors.getCalendar(this.state.localStore);
    const zeroDate = selectors.getZeroDateForCalendar(calendar);
    const earliestItemDate = selectors.getEarliestItemZeroDate(this.state.localStore);
    const thisWeekDate = dateFunctions.dateForThisWeek(calendar);

    return (
      <SettingsZeroDateModal
        defaultDate={zeroDate}
        earliestItemDate={earliestItemDate}
        thisWeekDate={thisWeekDate}
        onOk={this.onZeroDateDone}
        onCancel={this.onZeroDateCancel}
        calendar={calendar}
      />
    );
  }

  renderCalendarSettings() {
    let calendarProps = {
      localStore: this.state.localStore,
      fontSize: this.props.globalFontSize
    };
    //#!if iOS === true
// calendarProps.dispatchLocal = this.dispatchLocal;
// calendarProps.onDoneClick = this.onDoneClick;
// calendarProps.onCloseClick = this.onEditCalendarDone;
    //#!else
    calendarProps.onDoneClick = this.onEditCalendarDone;
    calendarProps.onCloseClick = this.onEditCalendarCancel;
    //#!endif

    return <CalendarSettingsModal {...calendarProps} />;
  }

  renderConfirmDeleteActionModal() {
    const enabledTypes = typeSelectors.getOrderedTypes(this.state.localStore);
    return (
      <SettingsConfirmDeleteActionModal
        localStore={this.state.localStore}
        deletedTypes={this.state.deletedTypesWithItems}
        enabledTypes={enabledTypes}
        onDoneClick={this.onConfirmDeleteActionDone}
        onCloseClick={this.onConfirmDeleteActionCancel}
      />
    );
  }

  renderStrictNarrativeActionModal() {
    return (
      <SettingsStrictNarrativeActionModal
        onDoneClick={this.onStrictNarrativeActionDone}
        onCloseClick={this.onStrictNarrativeActionCancel}
      />
    );
  }

  render() {
    return (
      <ModalViewStack>
        {this.renderSettingsModal()}
        {wrapEditingComponent(
          <Fragment>
            {this.state.advancedSettingsOpen ? this.renderAdvancedSettings() : null}
            {this.state.zeroDateOpen ? this.renderZeroDateModal() : null}
            {this.state.confirmDeleteActionOpen ? this.renderConfirmDeleteActionModal() : null}
            {this.state.editCalendarOpen ? this.renderCalendarSettings() : null}
            {this.state.strictNarrativeOptionOpen ? this.renderStrictNarrativeActionModal() : null}
          </Fragment>
        )}
      </ModalViewStack>
    );
  }
}

SettingsModal.propTypes = {
  localStore: PropTypes.object.isRequired,
  onDoneClick: PropTypes.func.isRequired,
  onCloseClick: PropTypes.func.isRequired,
  onSaveCustomClick: PropTypes.func.isRequired,
  isSyncEnabled: PropTypes.bool.isRequired,
  isStrictNarrativeViolated: PropTypes.bool.isRequired,
  globalFontSize: PropTypes.number.isRequired,
  isLicensingEnabled: PropTypes.bool.isRequired,

  //#!if harvard === true || mobile === true
  // From withScreenContext
  screenContext: PropTypes.object
  //#!endif
};

const mapStateToProps = state => {
  return {
    localStore: state.present,
    isSyncEnabled: syncSettingsSelectors.getSyncEnabled(state.present),
    isStrictNarrativeViolated: itemSelectors.getParentIdsViolatingStrictNarrativeStructure(state.present).size > 0,
    globalFontSize: preferencesSelectors.getGlobalFontSize(state.present),
    isLicensingEnabled: registrationSelectors.getIsLicensingEnabled(state.present)
  };
};

const readonlyActions = {
  onDoneClick: batchOperations.applySettings,
  onCloseClick: uiStateOperations.hideSettingsModal
};

const editingActions = {
  onSaveCustomClick: () => {
    // TODO: Implement this...
  }
};

const mapDispatchToProps = dispatch => mergeDispatchToProps(readonlyActions, editingActions, dispatch);

const exportedView = isHarvard || isMobile ? withScreenContext(SettingsModal) : SettingsModal;

export default connect(mapStateToProps, mapDispatchToProps)(exportedView);
